import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import CannyRouter from 'common/core/CannyRouter';

import ChangelogWidgetRoutes from './ChangelogWidgetRoutes';

import 'css/changelog-widget.scss';

class ChangelogWidgetApp extends Component {
  render() {
    const { history } = this.props;
    return <CannyRouter history={history} routes={ChangelogWidgetRoutes} />;
  }
}

export default hot(ChangelogWidgetApp);
